import { Box, Typography, useTheme } from '@mui/material';
import { ActivityTypeEnum } from '../../../types/activity';
import { renderActivitySchedule } from '../../ClientProgress/Progress';

interface IMagicSuggestionMiniCardProps {
  name: string;
  objective: string;
  frequency: ActivityTypeEnum;
  isSelected: boolean;
  onClick: () => void;
}
function MagicSuggestionMiniCard({
  name,
  objective,
  frequency,
  onClick = () => {},
  isSelected = true,
}: IMagicSuggestionMiniCardProps) {
  const theme = useTheme();

  return (
    <Box
      onClick={onClick}
      display="flex"
      width="100%"
      bgcolor={isSelected ? 'rgba(255, 221, 200, 0.25)' : '#fff'}
      p="16px"
      sx={{
        '&:hover': {
          backgroundColor: 'rgba(255, 221, 200, 0.25)',
          cursor: 'pointer',
          transition: 'transform 0.2s ease-in-out',
        },
      }}
    >
      <Box
        bgcolor="#fff"
        sx={{
          border: theme.borderStyles.commonBorders,
          borderRadius: '10px',
          overflow: 'hidden',
        }}
      >
        <Box display="flex" bgcolor="#fff" width="100%">
          <Box display="flex" flexDirection="column" p="10px" gap="10px">
            <Box gap="12px" display="flex" flexDirection="row">
              <Typography variant="bodyBold" color="primary.main">
                {name}
              </Typography>
              {renderActivitySchedule(frequency)}
            </Box>

            <Box
              sx={{
                overflow: 'auto',
                width: '100%',
                '&::-webkit-scrollbar': {
                  display: 'none',
                },
                msOverflowStyle: 'none',
                scrollbarWidth: 'none',
              }}
            >
              <Typography
                variant="bodyRegular"
                color="primary.main"
                sx={{
                  height: 'auto',
                }}
              >
                {objective}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box display="flex" justifyContent="center" alignItems="center" pl="16px">
        <img
          src="/assets/icons/arrow-pointer.svg"
          alt="arrow-right"
          style={{ opacity: isSelected ? 1 : 0 }}
        />
      </Box>
    </Box>
  );
}

export default MagicSuggestionMiniCard;
